import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=a420db7a&scoped=true"
import script from "./ContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a420db7a",
  null
  
)

export default component.exports